import { TableCell, TableRow } from "@/components/ui/table";
import { MetricTooltip } from "./MetricTooltip";
import { CompetitiveBooleanRowProps } from "../types/competitive-analysis";
import { translateMetric, getMetricDescription } from "@/utils/seoUtils";

export const CompetitiveBooleanRow = ({ 
  metricKey, 
  analyses 
}: CompetitiveBooleanRowProps) => (
  <TableRow>
    <TableCell className="font-medium flex items-center gap-2">
      {translateMetric(metricKey)}
      <MetricTooltip 
        label={translateMetric(metricKey)} 
        description={getMetricDescription(metricKey)} 
      />
    </TableCell>
    {analyses.slice(0, 3).map((analysis) => (
      <TableCell key={analysis.url} className="text-center">
        {analysis.boolean_criteria[metricKey] ? '✅' : '❌'}
      </TableCell>
    ))}
  </TableRow>
);